export default __webpack_public_path__ + "static/nextgen-banner-1-fb9ebf40dfa68b02e4cac74dd2c94870.webp";